import { volumeDisplayName } from '../formatBytes';
import type { SidebarPalette } from './sidebarPalettes';
import type { ExplorationVolume } from '../../types/exploration';

export interface AttachedVolumeRowData {
  volume: ExplorationVolume;
  name: string;
  totalSize: number;
  signalPct: number;
  lengthRatio: number;
}

export function buildAttachedVolumeRows(
  volumes: ExplorationVolume[],
  palette: SidebarPalette,
  signalKey: string
): AttachedVolumeRowData[] {
  const sorted = [...volumes].sort((a, b) => (b.size || 0) - (a.size || 0));
  const maxSize = Math.max(...sorted.map((v) => v.size || 0), 1);

  return sorted.map((volume) => {
    const totalSize = volume.size || 0;
    const signalSize = volume[palette.field] === signalKey ? totalSize : 0;
    const signalPct = totalSize > 0 ? (signalSize / totalSize) * 100 : 0;

    return {
      volume,
      name: volumeDisplayName(volume),
      totalSize,
      signalPct,
      lengthRatio: totalSize / maxSize,
    };
  });
}
